export function optionalNumber(e: string) {
  return e === '' ? undefined : parseInt(e, 10);
}
